import { isAuthSessionExpiredError } from '@shared/errors/auth-session-expired-error';
import { isAxiosError } from 'axios';

const MAX_RETRIES = 1;
// Auth failures are already handled by the axios interceptors; retrying only delays the user.
const NON_RETRYABLE_STATUSES: ReadonlySet<number> = new Set([401, 403]);

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES || isAuthSessionExpiredError(error)) {
    return false;
  }

  const status = isAxiosError(error) ? error.response?.status : undefined;
  return status === undefined || !NON_RETRYABLE_STATUSES.has(status);
}
